module.exports = __webpack_public_path__ + "img/5 color-storing.8f18d430.jpeg";